import React from "react";
import "../../assets/css/login.css";

const PrivacyPolicyPage = () => {
  return (
    <div className="container p-4 my-5" style={{ backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.05)" }}>
      <h1 className="mb-3">Privacy Policy</h1>
      <p className="text-muted">Last updated: June 03, 2026</p>
      <p>This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Builders World Forum Membership Portal and Backend Admin Panel, and tells You about Your privacy rights under applicable local and national laws.</p>
      <p>We use Your Personal data to provide, maintain, and improve the Service. By registering an account on the Portal, You agree to the collection and use of information in accordance with this Privacy Policy.</p>
      
      <hr />

      <h2>Interpretation and Definitions</h2>
      <h3>Definitions</h3>
      <p>For the purposes of this Privacy Policy:</p>
      <ul>
        <li>
          <p><strong>Account</strong> means a unique account created for You to access our Membership Portal or Admin Panel features.</p>
        </li>
        <li>
          <p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to <strong>Builders World Forum</strong></p>
        </li>
        <li>
          <p><strong>Website / Portal</strong> refers to Builders World Forum, accessible from <a href="https://www.buildersworldforum.com/" target="_blank" rel="noreferrer">https://www.buildersworldforum.com/</a>.</p>
        </li>
        <li>
          <p><strong>Personal Data</strong> is any information that relates to an identified or identifiable business professional, individual, builder, or entity.</p>
        </li>
        <li>
          <p><strong>Service</strong> refers to the digital Web Application, Membership Portal, and Backend Admin Panel features provided through the Website.</p>
        </li>
        <li>
          <p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the portal infrastructure itself (for example, session tracking, admin login logs, or page visit duration).</p>
        </li>
      </ul>

      <h2>Collecting and Using Your Personal Data</h2>
      <h3>Types of Data Collected</h3>
      
      <h4>Personal Data</h4>
      <p>While registering or updating your business profile on Our Portal, We may ask You to provide Us with certain personally identifiable information that can be used to showcase your business listing or contact you. Personally identifiable information includes, but is not limited to:</p>
      <ul>
        <li>First Name and Last Name</li>
        <li>Business / Company Name and Designation</li>
        <li>Email Address and Mobile Number</li>
        <li>Business Address, State, Province, ZIP/Postal code</li>
        <li>Professional details (e.g., License numbers, Portfolios, GST/PAN if applicable for verification)</li>
      </ul>

      <h4>Usage Data & Activity Logs</h4>
      <p>Usage Data is collected automatically when accessing the backend platform to monitor internal activities. This includes your Device's IP address, browser type, pages visited within the Admin/Member Panel, date and time stamps, and log parameters to prevent unauthorized account breaches.</p>

      <h4>Information Collected while Uploading Media</h4>
      <p>While using Our Portal features (such as setting up a member directory profile or uploading project portfolios), We may collect, with Your prior permission:</p>
      <ul>
        <li>Company logos, banners, project pictures, and other media documents from your device's storage library.</li>
      </ul>
      <p>This media is securely hosted and stored on our server infrastructure to visually display your professional profile on the forum directory.</p>

      <h3>Use of Your Personal Data</h3>
      <p>The Company uses the collected Personal Data to manage Your Account registration, maintain directory listings, handle platform security updates, contact you via email or SMS/calls regarding network notifications, and analyze portal usage patterns for operational improvements.</p>

      <h3>Data Retention & Right to Deletion</h3>
      <p>The Company will retain Your Personal Data only for as long as your membership account remains active or as required by corporate compliance laws. You have the full right to update, amend, or request the deletion of Your account and personal details at any time by signing in to Your profile settings or directly contacting the Administrator.</p>

      <h2>Security of Your Personal Data</h2>
      <p>The security of your technical data is paramount. We implement standard encryption metrics to prevent database exploits, but remember that no transmission method over the internet is 100% secure. While we strive to protect your professional listings, absolute data security cannot be guaranteed.</p>

      <h2>Children's Privacy</h2>
      <p>Our forum is purely a professional B2B business networking service. It does not address or intentionally accept account setups from anyone under the age of 18.</p>

      <h2>Changes to this Privacy Policy</h2>
      <p>We may update Our Privacy Policy from time to time. We will notify You of any material changes by updating the &quot;Last updated&quot; date at the top of this page or via portal dashboard announcements.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, You can contact us:</p>
      <ul className="list-unstyled ps-3">
        <li><strong>By email:</strong> buildersworldforum@gmail.com</li>
        <li><strong>By phone number:</strong> +91 94441 31213</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicyPage;